import script from "./PaymentStep.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentStep.vue?vue&type=script&setup=true&lang=js"

import "./PaymentStep.vue?vue&type=style&index=0&id=7c78fd03&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c78fd03"]])

export default __exports__